<template>
    <div :class="`${this.isShowingMenu?'opened':''} resources`">
      <div class="resources-bar" id="resources-bar" :style="navbarStyle">
          <div class="resources-title">學習資源</div>
          <div>
            <div class="resources-bar-btn" :class="{ 'active' : isActive('AllResources') }">
                <router-link :to="{name: 'AllResources'}"><div>學習資源</div></router-link>
            </div>
            <div v-if="isTeacher" class="resources-bar-btn" :class="{ 'active' : isActive('MyResources') }">
                <router-link :to="{name: 'MyResources'}" ><div>我的資源</div></router-link>
            </div>
            <div class="resources-bar-btn" :class="{ 'active' : isActive('BookmarkResources') }">
                <router-link :to="{name: 'BookmarkResources'}" ><div>我的書籤</div></router-link>
            </div>
          </div>
      </div>
      <div id="menu_button" @click="trigger_menu">
        <eva-icon fill="#397f1f" name="menu-outline" style="margin-right:0.2rem;"></eva-icon>
      </div>
      <div class="nav_background" @click="hide_menu" :style="navBackgroundStyle">
      </div>
      <router-view :style="{'width': contentWidth}"/>
    </div>
</template>

<style scoped>
.resources{
    display: flex;
    position: relative;
}
.resources-bar{
    flex: 0 0 18rem;
    display: flex;
    flex-direction: column;
}

.resources-title{
    margin: 3rem 2rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #397f1f;
}

.resources-bar-btn{
    margin: 1rem;
    font-size: 1.2rem;
    background-color: #99cc33;
    display: flex;
    width: 12rem;
    justify-content: center;
    align-self: center;
    padding: 1rem;
    border-radius: 1rem;
}
.resources-bar-btn div{
    color: white;
}
.active{
    background-color: #397f1f;
}
  #menu_button {
    display: none;
  }
  @media screen and (max-width: 790px) {
    #menu_button {
      display: block;
      z-index: 101;
      position: absolute;
      top: 0;
      left: 0;
    }
    #resources-bar{
      right: 100%;
      transition: right 2s;
      position: absolute;
      background: white;
      overflow-y: scroll;
    }
    .opened #resources-bar{
      right: unset;
      z-index: 100;
    }
    .nav_background{
      width: 100vw;
      position: absolute;
      display: none;
    }
    .opened .nav_background{
      background: #000A;
      z-index: 99;
      display: block;
    }
  }
</style>
<script>
import $ from 'jquery'
import { EvaIcon } from 'vue-eva-icons'
export default {
  components: {
    [EvaIcon.name]: EvaIcon
  },
  data () {
    return {
      contentWidth: '0px',
      isShowingMenu: false,
      navBackgroundStyle: '',
      navbarStyle: ''
    }
  },
  computed: {
    isTeacher: function () {
      return this.$parent.isTeacher
    },
    isMobile: function () {
      return window.screen.width < 790
    }
  },
  methods: {
    isActive (tag) {
      return this.$route.matched.some(r => r.name === tag)
    },
    show_menu: function (e) {
      this.isShowingMenu = true
    },
    hide_menu: function (e) {
      this.isShowingMenu = false
      console.log('hide menu')
    },
    trigger_menu: function (e) {
      if (this.isShowingMenu) {
        this.hide_menu()
      } else {
        this.show_menu()
      }
      e.stopPropagation()
    }
  },
  watch: {
    isShowingMenu: function (isShow) {
      if (isShow) {
        $('html').css('overflow-y', 'hidden')
      } else {
        $('html').css('overflow-y', 'auto')
      }
    }
  },
  mounted () {
    console.log(this)
    this.$nextTick(function () {
      if (!this.isMobile) {
        let width = document.getElementById('resources-bar') !== null ? document.getElementById('resources-bar').offsetWidth : 0
        this.contentWidth = `calc( 100vw - ${width}px )`
      } else {
        this.contentWidth = `100vw`
      }
      this.navBackgroundStyle = `height: calc( 100vh + ${$('#footer').outerHeight()}px )`
      this.navbarStyle = `height: calc(100vh - ${$('#appHeader').outerHeight()}px )`
      $('#resources-bar a').click(() => {
        console.log('a clicked')
        this.hide_menu()
      })
    })
  }
}
</script>
